export default "__VITE_ASSET__BK26piuv__"